import React from 'react';

/**
 * Full-screen dimmed spinner shown while a payments page is fetching. Every
 * new_payments page renders the same overlay markup, so it lives here as one
 * source. Renders nothing when not loading.
 *
 * @param {Object} props
 * @param {boolean} props.loading - Whether to show the overlay.
 * @returns {JSX.Element|null}
 */
const LoadingOverlay = ({ loading }) =>
  loading ? (
    <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-50 flex flex-col items-center justify-center">
      <div className="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
    </div>
  ) : null;

export default LoadingOverlay;
